/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getPersonOfConcernList = (payload, callback) =>
  req.list(
    c.GET_PERSON_OF_CONCERN,
    'api/v1/rpt/administrator/land/settings/land_person_of_concern',
    payload,
    callback
  );

export const getSinglePersonOfConcern = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_PERSON_OF_CONCERN,
    `api/v1/rpt/administrator/land/settings/land_person_of_concern/${id}`,
    payload,
    callback
  );

export const createPersonOfConcern = (payload, callback) =>
  req.create(
    c.CREATE_PERSON_OF_CONCERN,
    'api/v1/rpt/administrator/land/settings/land_person_of_concern',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updatePersonOfConcern = (id, payload, callback) =>
  req.update(
    c.UPDATE_PERSON_OF_CONCERN,
    `api/v1/rpt/administrator/land/settings/land_person_of_concern/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removePersonOfConcern = (id, payload, callback) =>
  req.remove(
    c.REMOVE_PERSON_OF_CONCERN,
    `api/v1/rpt/administrator/land/settings/land_person_of_concern/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getLandClassificationsList = (payload, callback) =>
  req.list(
    c.GET_LAND_CLASSIFICATIONS,
    'api/v1/rpt/administrator/land/settings/land_classifications?isPaginate=1',
    payload,
    callback
  );

export const getSubClassificationsList = (id, payload, callback) =>
  req.list(
    c.GET_SUB_CLASSICATION_LIST,
    `api/v1/rpt/administrator/land/settings/land_classifications/${id}/land_sub_classifications`,
    payload,
    callback
  );

export const getLocationList = (payload, callback) =>
  req.list(
    c.GET_LOCATION_LIST,
    'api/v1/rpt/administrator/settings/locations',
    payload,
    callback
  );

export const getOrdinanceRevisionList = (payload, callback) =>
  req.list(
    c.GET_ORDINANCE_REVISION,
    'api/v1/rpt/administrator/settings/ordinance_revisions',
    payload,
    callback
  );

export const getDistrictList = (payload, callback) =>
  req.list(
    c.GET_DISTRICT_LIST,
    'api/v1/rpt/administrator/settings/districts',
    payload,
    callback
  );

